export default __webpack_public_path__ + "static/media/reports_icon.1bd73e72.svg";